import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import  TableCourse  from '../../../ui-kit/Table/TableCourse'
import {
  useGetTeamCourseProgressQuery,
  useLazyExportTeamCourseProgressQuery
} from '../../../slices/dashboardApiSlice'
import { FormPaper, TableContainer, Title, ResponsiveContainer, ResponsiveHeader, ResponsiveFilters } from '../../Survey/Survey.styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { formatMessage } from '../../../locale'
import PaginableList from '../../../ui-kit/PaginableListSurvey';
import { useMedia } from '../../../ui-kit/utils/media' 
import { Button } from '../../../ui-kit'
import Spinner from '../../../ui-kit/Spinner/Spinner'
import { DashboardPermissions } from '../../../enum/Dashboard/DashboardPermissions';

export const TaskList = () => {
  const { isMobile, isTablet, isWide } = useMedia()
  const navigate = useNavigate()

  const { userCompany, permissions } = useSelector((state: RootState) => state.auth)
  const [exportTeamCourseProgress] = useLazyExportTeamCourseProgressQuery()

  const canDo = (permission: string) => {
    return permissions && !!permissions[permission]
  }

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState<any[]>([]);;
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);


  const handleExport = async () => {
    try {
        const blob = await exportTeamCourseProgress({}).unwrap(); 
        if (blob) {
            const url = URL.createObjectURL(blob); 
            const a = document.createElement('a'); 
            a.href = url;
            a.download = 'team_results.xlsx'; 
            document.body.appendChild(a);
            a.click(); 
            document.body.removeChild(a); 
            URL.revokeObjectURL(url);
        }
    } catch (error) {
        console.error('Error exporting team results:', error);
    }
};


  return (
    <PaginableList
      query={useGetTeamCourseProgressQuery} currentPage={currentPage}
      searchTerm={searchTerm} statusPaginated={selectedStatus}
      startDate={startDate} endDate={endDate}
    >
      {(courses, isLoading, error, refetch) => {

        if (isLoading) return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}><Spinner/></div>
        if (error) return <div><p>{formatMessage({ id: 'loading.errorLoadingCourseDashboard', defaultMessage: 'Error while loading course' })}</p></div>

        const viewSurveyAction = (courseId: number) => navigate(`/course-stats/${courseId}`)
        
        const columns = [
          formatMessage({ id: 'dashboardCourse.columns.course', defaultMessage: 'Course' }),
          formatMessage({ id: 'dashboardCourse.columns.assigned', defaultMessage: 'Assigned' }),
          formatMessage({ id: 'dashboardCourse.columns.assignedAt', defaultMessage: 'Assigned at' }),
          formatMessage({ id: 'dashboardCourse.columns.completed', defaultMessage: 'Completed' }),
          formatMessage({ id: 'dashboardCourse.columnsPersonal.deadline', defaultMessage: 'Deadline' }),
          formatMessage({ id: 'dashboardCourse.columns.assignedTo', defaultMessage: 'Assigned to' }),
        ];
      
        const courseTableData: any = courses?.map((course: any) => ({
          id: course.course_id,
          [columns[0]]: course.title,
          [columns[1]]: course?.total_in_progress,
          [columns[2]]: course?.assigned_date,
          [columns[3]]: course?.total_completed,
          [columns[4]]: course?.expired_at,
          [columns[5]]: course?.entity_types,
        })) || [];
      
        const canSeeCourseProgress = canDo(DashboardPermissions.isAllowedSeeDashboardCourseProgress);

        return <>
        {courses?.length > 0 ? (
        <FormPaper>
          <TableContainer>
            {isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spinner />
              </div>
            ) : (
              <ResponsiveContainer>
                <ResponsiveHeader>
                  <Title style={{ fontSize: isMobile ? '1.5rem' : '1.8rem' }}>
                    {formatMessage({ id: 'dashboardCourse.teamCourseStatistics', defaultMessage: 'Team courses statistics' })}
                  </Title>
                 {canSeeCourseProgress && <Button appearance="primary" onClick={() => handleExport()}>
                    {formatMessage({ id: 'dashboardCourse.exportToExcel', defaultMessage: 'Export to Excel' })}
                  </Button>}
                </ResponsiveHeader>
                <ResponsiveFilters style={{ marginBottom: '2rem' }} />
                <TableCourse
                  columns={columns}
                  rows={courseTableData}
                  {...(canSeeCourseProgress && { onSelect: (id: any) => viewSurveyAction(id) })}
                />
              </ResponsiveContainer>
            )}
          </TableContainer>
        </FormPaper>
      ) :  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
              <h1>{formatMessage({ id: 'task.noCourses', defaultMessage: 'No courses available' })}</h1>
            </div>
       }
        </>;
      }}
    </PaginableList>
  );
};

export default TaskList; 